import {Controller} from "@hotwired/stimulus"

export class RefreshController extends Controller {

	connect() {
		this.interval = setInterval(() => {
			Turbo.visit(window.location.href, { action: "replace" })
		}, 60000)
	}

	disconnect() {
		clearInterval(this.interval)
	}

	preventMorphElement(event) {
		if (event.target.classList.contains("modal-backdrop")) {
			event.preventDefault()
		}
	}

	preventMorphAttributes(event) {
		if (event.target.tagName === "BODY") {
			event.preventDefault()
		}
		if (event.target.classList.contains("tab-pane") || event.target.classList.contains("district-operations")) {
			const {attributeName} = event.detail
			if (attributeName === "class") event.preventDefault()
		}
	}
}